export const siteName = '17吃瓜网';

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '可投线索', to: '/#categories' },
  { label: '投稿流程', to: '/#flow' },
  { label: '投稿指南', to: '/guide' },
  { label: '关于我们', to: '/about' },
];

export const heroStats = [
  { value: '36 小时', label: '平均核实周期' },
  { value: '9 类', label: '开放线索方向' },
  { value: '100%', label: '匿名可全程保密' },
];

export const heroTicker = [
  '匿名投稿通道已开放',
  '支持私信爆料 · 图文均可',
  '所有线索先核实后发布',
  '投稿人身份严格保密',
  '素人线索同样认真对待',
  '行业内部消息优先处理',
];

export const trustPoints = [
  {
    icon: 'ri-shield-keyhole-line',
    title: '匿名真的匿名',
    desc: '投稿时勾选匿名，你的昵称与联系方式不会进入公开内容，编辑只在核实需要时单独联系你。',
  },
  {
    icon: 'ri-article-line',
    title: '先核实再发布',
    desc: '线索进入编辑库后由编辑交叉验证，无法确认的信息不会被写成结论，避免误伤无关的人。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '素人投稿也受理',
    desc: '不要求你是圈内人。同事之间的一句话、活动现场的一张图，都可能是值得追下去的线索。',
  },
  {
    icon: 'ri-time-line',
    title: '进度有回音',
    desc: '留下联系方式后，线索被采用会收到编辑回信；即便这次未采用，也会告诉你大致原因。',
  },
];

export const leadCategories = [
  {
    name: '明星动态',
    desc: '公开行程、剧组动向、代言变动、出入场合等与艺人本职工作相关的动向线索。',
    icon: 'ri-star-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20editorial%20collage%20of%20a%20vintage%20spotlight%20and%20theater%20curtain%20in%20warm%20terracotta%20and%20cream%20paper%20texture%2C%20abstract%20graphic%20illustration%2C%20no%20people%2C%20soft%20grain%2C%20clean%20background&width=720&height=520&seq=gossip-cat-star-01&orientation=landscape',
  },
  {
    name: '恋情绯闻',
    desc: '公开场合同框、恋情进展、求婚或分手等信息，请尽量说明时间地点与可佐证的照片来源。',
    icon: 'ri-heart-3-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20two%20overlapping%20paper%20hearts%20on%20a%20warm%20sand%20background%2C%20editorial%20minimal%20graphic%20art%2C%20terracotta%20and%20amber%20palette%2C%20subtle%20paper%20texture%2C%20no%20text&width=720&height=520&seq=gossip-cat-love-02&orientation=landscape',
  },
  {
    name: '片场幕后',
    desc: '剧组改档、换角、补拍、拍摄现场状况等一手信息，附上大致日期与城市会更容易核实。',
    icon: 'ri-clapperboard-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20minimal%20illustration%20of%20a%20film%20clapperboard%20and%20a%20folded%20paper%20script%20on%20a%20warm%20cream%20desk%2C%20editorial%20graphic%20art%2C%20terracotta%20accents%2C%20flat%20lighting%2C%20no%20people&width=720&height=520&seq=gossip-cat-set-03&orientation=landscape',
  },
  {
    name: '综艺内幕',
    desc: '节目录制规则、剪辑争议、嘉宾临时替换、赛制安排等观众看不到的幕后情况。',
    icon: 'ri-tv-2-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20retro%20television%20set%20and%20stage%20lights%20on%20a%20warm%20amber%20backdrop%2C%20editorial%20minimal%20graphic%20art%2C%20paper%20texture%2C%20no%20text%2C%20no%20people&width=720&height=520&seq=gossip-cat-variety-04&orientation=landscape',
  },
  {
    name: '网红直播',
    desc: '直播间数据异常、带货翻车、私下纠纷、账号交易等与直播电商生态相关的线索。',
    icon: 'ri-live-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20smartphone%20ring%20light%20and%20microphone%20on%20a%20warm%20sand%20background%2C%20editorial%20minimal%20graphic%20art%2C%20terracotta%20and%20green%20accents%2C%20no%20people&width=720&height=520&seq=gossip-cat-live-05&orientation=landscape',
  },
  {
    name: '饭圈事件',
    desc: '打投集资去向、应援活动争议、粉丝组织内部纠纷，建议附上公开截图与时间线。',
    icon: 'ri-group-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20overlapping%20speech%20bubbles%20and%20small%20flags%20on%20a%20warm%20cream%20background%2C%20editorial%20minimal%20graphic%20art%2C%20terracotta%20accents%2C%20no%20text&width=720&height=520&seq=gossip-cat-fandom-06&orientation=landscape',
  },
  {
    name: '行业黑幕',
    desc: '合同陷阱、数据注水、刷量报价、音乐版权灰色操作等结构性问题，可匿名提供材料。',
    icon: 'ri-file-warning-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20minimal%20illustration%20of%20stacked%20documents%20and%20a%20magnifying%20glass%20on%20a%20warm%20sand%20surface%2C%20editorial%20graphic%20art%2C%20terracotta%20and%20amber%20palette%2C%20no%20text&width=720&height=520&seq=gossip-cat-industry-07&orientation=landscape',
  },
  {
    name: '素人投稿',
    desc: '不局限娱乐圈。职场、校园、网络热点中值得被记录的真实经历，都可以投递给我们。',
    icon: 'ri-chat-quote-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20handwritten%20letter%20and%20a%20pen%20on%20a%20warm%20cream%20desk%2C%20editorial%20minimal%20graphic%20art%2C%20terracotta%20accents%2C%20soft%20grain%2C%20no%20people&width=720&height=520&seq=gossip-cat-public-08&orientation=landscape',
  },
];

export const submitFlow = [
  {
    step: '01',
    title: '填写投稿入口',
    desc: '在投稿入口页填写线索标题与详情，选择线索类型，决定是否匿名，整个过程不超过三分钟。',
  },
  {
    step: '02',
    title: '进入编辑线索库',
    desc: '提交后线索会进入编辑线索库，按类型分派给对应方向的编辑，并与你自己的联系方式绑定对应。',
  },
  {
    step: '03',
    title: '交叉核实',
    desc: '编辑会尝试寻找第二来源、核对公开记录与时间线。材料不完整的会回信向你补充细节。',
  },
  {
    step: '04',
    title: '整理成稿并回信',
    desc: '确认后的线索会整理成可读内容，并注明「经核实的说法」。被采用时编辑会回信告知你结果。',
  },
];

export const editorPrinciples = [
  {
    icon: 'ri-error-warning-line',
    title: '不做没有来源的结论',
    desc: '单一匿名说法不足以成稿。我们宁愿放弃一条热闹的线索，也不把猜测写成事实标题。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '来源高于流量',
    desc: '投稿人的身份信息只存在于编辑内部，任何对外内容都不会出现可用于定位投稿人的细节。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '给被提及方回应机会',
    desc: '内容涉及具体个人或公司时，会先留出回应窗口，并如实呈现对方的说法。',
  },
  {
    icon: 'ri-delete-bin-6-line',
    title: '不发布无关隐私',
    desc: '与线索本身无关的家庭住址、证件信息、未成年人信息一律不会出现在内容中。',
  },
];

export const testimonials = [
  {
    name: '匿名投稿人 · 影视从业者',
    role: '剧组工作人员',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20avatar%20portrait%20of%20a%20person%20in%20profile%20view%2C%20flat%20graphic%20style%2C%20terracotta%20and%20cream%20palette%2C%20simple%20solid%20background%2C%20no%20text&width=160&height=160&seq=gossip-avatar-01&orientation=squarish',
    quote:
      '本来担心填了联系方式会被人查到，结果编辑全程只在一个加密渠道跟我确认细节，稿子出来后也确实看不到任何能指向我的信息。',
  },
  {
    name: '小满',
    role: '关注文娱多年的普通读者',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20avatar%20portrait%20of%20a%20young%20reader%20with%20short%20hair%2C%20flat%20graphic%20style%2C%20amber%20and%20sand%20palette%2C%20simple%20solid%20background%2C%20no%20text&width=160&height=160&seq=gossip-avatar-02&orientation=squarish',
    quote:
      '我在现场拍了两张图，抱着试试的心态投了。两天后收到回信说已经核实，还专门说明为什么这篇没有直接点名，感觉是有底线的平台。',
  },
  {
    name: '夜航船',
    role: '长期线索投递者',
    avatar:
      'https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20avatar%20portrait%20of%20a%20calm%20person%20wearing%20glasses%2C%20flat%20graphic%20style%2C%20muted%20green%20and%20cream%20palette%2C%20simple%20solid%20background%2C%20no%20text&width=160&height=160&seq=gossip-avatar-03&orientation=squarish',
    quote:
      '对比过好几家投稿入口，这里的表单会真的问你时间、地点和来源，而不是随便收一句「有瓜私聊」，填起来就知道对方是认真在做核实。',
  },
];

export const homeFaqs = [
  {
    q: '投稿一定要实名吗？会不会被公开？',
    a: '不需要实名。你在投稿入口选择匿名投稿后，昵称和联系方式只会进入编辑内部线索库，用于必要时向你核实细节，不会出现在任何公开内容里。如果你希望署化名，也可以在表单里自行填写喜欢的称呼。',
  },
  {
    q: '什么样的线索更容易被采用？',
    a: '有时间、有地点、有可佐证材料的线索最受欢迎。哪怕只是一张现场照片或一段公开截图，只要能和你说的时间线对上，都会显著提高采用概率。单纯的「听说某某怎样」因为没有核实路径，通常很难成稿。',
  },
  {
    q: '投稿之后多久会有回音？',
    a: '线索进入编辑库后，一般会在 36 小时内完成初步判断。被采用的线索编辑会回信告知，需要补充材料的会再联系你；如果判断暂时无法核实，也会简单说明原因，不会让你一直等下去。',
  },
  {
    q: '投了但没被采用，材料会被怎么处理？',
    a: '未采用的线索同样保存在内部线索库中，仅编辑可见。如果后续出现新的公开信息可以把这条线索补全，编辑可能会重新启用它。你可以随时通过投稿时的联系方式要求删除自己提交的内容。',
  },
  {
    q: '可以通过私信直接爆料吗？',
    a: '可以。除了投稿入口，你也可以通过站内列出的私信渠道直接联系编辑。不过为了信息完整，仍建议尽量使用投稿入口提交，表单会把时间、地点、类型等字段整理好，减少来回确认的次数。',
  },
  {
    q: '投稿会给我报酬吗？',
    a: '目前投稿属于线索征集，不承诺固定报酬。如果线索被采用并发展为深度内容，编辑会在回信中与你沟通是否愿意进一步参与，以及相应的署名或合作方式。',
  },
];

export const quickFacts = [
  { icon: 'ri-mail-send-line', label: '投稿入口', value: '全天 24 小时开放' },
  { icon: 'ri-map-pin-time-line', label: '线索受理', value: '提交后 36 小时内初判' },
  { icon: 'ri-mail-lock-line', label: '匿名投稿', value: '身份信息仅编辑可见' },
];

export const guideToc = [
  { id: 'before', label: '投稿前须知' },
  { id: 'anonymous', label: '匿名与署名区别' },
  { id: 'private', label: '私信爆料渠道' },
  { id: 'evidence', label: '证据与材料要求' },
  { id: 'timeline', label: '线索处理时间线' },
  { id: 'privacy', label: '隐私保护政策' },
  { id: 'faq', label: '常见问题' },
];

export const guideFaqs = [
  {
    q: '匿名投稿之后，编辑还能联系到我吗？',
    a: '可以，但仅限你主动留下的联系方式。匿名指的是不对外公开你的身份，而不是切断与编辑的沟通渠道。如果你连回信邮箱都没有留下，编辑就只能依据线索本身判断，无法向你追问细节。',
  },
  {
    q: '我提交的截图、照片会被直接公开吗？',
    a: '不会直接公开。所有图片会先由编辑检查是否包含可定位到普通个人的信息，例如证件、住址、门牌号、清晰的车牌等。确需使用的部分会做必要遮挡处理，并在内容中说明来源性质。',
  },
  {
    q: '如果我的线索和后来查证的事实有出入怎么办？',
    a: '我们会以核实结果为准。若你提供的说法与多方证据不符，编辑会如实修正内容，必要时在文末说明更正情况，而不是硬撑着保留原说法。这也是我们不接受单一匿名来源就成稿的原因。',
  },
  {
    q: '同一条线索可以同时投给多个平台吗？',
    a: '可以，但我们希望你在投稿时顺带说明。如果多家平台都在追同一条线索，编辑会据此调整核实节奏，避免重复投入资源，也更方便你比较各家后续的处理方式。',
  },
  {
    q: '投稿被采用之后，会公开我的名字吗？',
    a: '取决于你在表单里的选择。选择匿名投稿，内容中不会出现任何可公开的称呼；选择署名投稿，则会使用你填写的化名或称呼，并提前与你确认如何表述。',
  },
  {
    q: '未成年人可以投稿吗？',
    a: '不建议未成年人独立投稿涉及他人的敏感线索。如果确有需要反映的情况，请先与监护人沟通，或改为向学校、家长等可信渠道反映，我们不接收涉及未成年人隐私的线索。',
  },
];

export const aboutVoices = [
  {
    name: '编辑侧观察',
    role: '线索库日常记录',
    quote: '每天收到的线索里，真正能被采用的不到三成。但恰恰是这不到三成，撑起了我们对「投稿入口」这件事的信心。',
  },
  {
    name: '一位连续投稿者',
    role: '两年内投递 11 条线索',
    quote: '被采用过三次，也被退回八次。退回的那八次，编辑都写了原因，这比一句「暂不采用」有用得多。',
  },
  {
    name: '前媒体从业者',
    role: '现为普通读者',
    quote: '这个行业的门槛其实在核实。谁能把核实流程讲清楚，谁就值得优先被信任。',
  },
];

export const aboutValues = [
  {
    icon: 'ri-eye-line',
    title: '定位：做通道，不做判官',
    desc: '我们不生产结论，只负责把线索接住、核实清楚、如实呈现。谁对谁错由证据说话，不由流量说话。',
  },
  {
    icon: 'ri-plant-line',
    title: '理念：长期主义和慢核实',
    desc: '一条线索晚两天发布，通常比发出去再更正要好。我们愿意为核实付出时间，而不是抢那一小时的热度。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '原则：投稿人优先',
    desc: '在流量与投稿人安全之间发生冲突时，永远优先保护投稿人。这是我们所有流程设计的起点。',
  },
];